<template>
  <nav class="navbar navbar-expand-lg bg-mintgroen">
    <div class="d-flex justify-content-between align-items-center">
      <!-- <svg xmlns="http://www.w3.org/2000/svg" class="d-none d-lg-block menu-icon mr-2" width="28" height="28" viewBox="0 0 20 20" fill="currentColor" @click="showing = !showing">
        <path fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd" />
      </svg> -->
      <span class="d-flex align-items-center">
        <div class="circle"></div>
        <span> Logo </span>
      </span>

      <button
        type="button"
        class="navbar-toggler navbar-toggler-right"
        :class="{ toggled: $sidebar.showSidebar }"
        aria-controls="navigation-index"
        aria-expanded="false"
        aria-label="Toggle navigation"
        @click="toggleSidebar"
      >
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end">
        <!-- <ul class="nav navbar-nav mr-auto">
          <li class="nav-item">
            <a class="nav-link" href="#" data-toggle="dropdown">
              <i class="nc-icon nc-palette"></i>
            </a>
          </li>
          <FormDropdown tag="li">
            <template slot="title">
              <i class="nc-icon nc-planet"></i>
              <b class="caret"></b>
              <span class="notification">5</span>
            </template>
            <a class="dropdown-item" href="#">Notification 1</a>
            <a class="dropdown-item" href="#">Notification 2</a>
            <a class="dropdown-item" href="#">Notification 3</a>
            <a class="dropdown-item" href="#">Notification 4</a>
            <a class="dropdown-item" href="#">Another notification</a>
          </base-dropdown>
          <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="nc-icon nc-zoom-split"></i>
              <span class="d-lg-block">&nbsp;Search</span>
            </a>
          </li>
        </ul> -->
        <ul class="navbar-nav ml-auto">
          <!-- <li class="nav-item">
            <a class="nav-link" href="#">
              Account
            </a>
          </li>
          <FormDropdown title="Dropdown">
            <a class="dropdown-item" href="#">Action</a>
            <a class="dropdown-item" href="#">Another action</a>
            <a class="dropdown-item" href="#">Something</a>
            <a class="dropdown-item" href="#">Another action</a>
            <a class="dropdown-item" href="#">Something</a>
            <div class="divider"></div>
            <a class="dropdown-item" href="#">Separated link</a>
          </base-dropdown> -->
          <div class="nav-item">
            <button class="nav-link with-border">
              <img src="/img/navbar-icons/search.svg" alt="" width="17" height="17" />
            </button>
          </div>
          <li class="nav-item">
            <button class="nav-link" id="logout" @click="logOut">
              <img
                width="17"
                height="17"
                src="/img/navbar-icons/logout.svg"
                alt=""
              />
            </button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      showing: this.value || false,
      activeNotifications: false,
    };
  },
  methods: {
    async logOut() {
      this.$logout();
    },

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
  },
  watch: {
    value(val) {
      this.showing = val;
    },
    showing(val) {
      this.$emit("input", val);
    },
  },
};
</script>

<style scoped>
.menu-icon,
span {
  color: #8888;
  cursor: pointer;
}

.bg-mintgroen {
  background: #33c9d2;
}
.circle {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid #000;
  background-color: #fff;
}
.circle + span {
  margin-left: 13px;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
    linear-gradient(0deg, #000000, #000000);
  background-clip: text;
  text-transform: uppercase;
  font-weight: 800;
}
.with-border {
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
}

.navbar {
  position: absolute;
  padding-left: 12px;
  top: 0;
  left: 0;
  z-index: 45;
  width: 100%;
}

@media (max-width: 991px) {
  .navbar {
    position: fixed;
  }
}

@media (min-width: 992px) {
  .navbar {
    padding: 0px;
    padding-left: 12px;
  }
}

.navbar > div, .navbar-collapse, .navbar-collapse > div {
  width: 100%;
  min-height: 40px;
}

.nav-item > button {
  display: flex;
  align-items: center;
  min-height: 40px;
}

.navbar-collapse {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

</style>
